module.exports = __webpack_public_path__ + "static/web-painting-9-c409f373be5a7a13f92508c3bf68d7fb.jpg";